function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.076,6.378l-.407-.29.407.29L14,.863l3.924,5.516.407-.29-.407.29a4.419,4.419,0,0,1-.558,5.783,4.9,4.9,0,0,1-6.732,0A4.419,4.419,0,0,1,10.076,6.378Zm-.9,14a4.419,4.419,0,0,1-.558,5.783,4.9,4.9,0,0,1-6.732,0,4.419,4.419,0,0,1-.558-5.783l-.407-.29.407.29L5.25,14.863l3.924,5.516.407-.29Zm17.5,0a4.419,4.419,0,0,1-.558,5.783,4.9,4.9,0,0,1-6.732,0,4.419,4.419,0,0,1-.558-5.783l-.407-.29.407.29,3.924-5.516,3.924,5.516.407-.29Z",
  transform: "translate(0.176)",
  fill: "none",
  stroke: "#383a36",
  strokeWidth: 1
});

var SvgWaterIcon = function SvgWaterIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28.352,
    height: 28,
    viewBox: "0 0 28.352 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWaterIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/water-icon.924abb66.svg";
export { ForwardRef as ReactComponent };